module.exports = __webpack_public_path__ + "media/images/countryrect/id-69f34543f62060891c4e22026715dc92.svg";